import React, { Component } from "react";
import constants from "../../../utils/constants";

class OktaCallback extends Component {
  componentDidMount() {
    window.location.replace(
      `${constants.BASE_URL}/api/auth/okta/processResponse${window.location.search}`
    );
  }

  render() {
    return <p>Cargando...</p>;
  }
}
export default OktaCallback;
